// import { ToastContainer } from "react-toastify";
// import GamePage from "./component/GamePage";
// import CutPage from "./component/CutPage";
// import Login from "./component/Login";
// import { Route, Routes } from "react-router-dom";
// import { useContext } from "react";
// import { Context } from "./Context/Context";
// import { RotatingLines } from "react-loader-spinner";
// import Deposit from "./component/Deposit";
// import DepositHistory from "./component/DepositHistory";
// import WithdrawHistory from "./component/WithdrawHistory";
// import AddClient from "./component/AddClient";
// import EditClient from "./component/EditClient";
// import AddGame from "./component/AddGame";
// import DeleteJantri from "./component/DeleteJantri";
// import RechargePlans from "./component/RechargePlans";
// import Withdraw from "./component/Withdraw";
// import LoginP from "./component/LoginP";
// import screenOrientation from "screen-orientation";
// import HelpSupport from "./component/HelpSupport";
// import BetHistory from "./component/BetHistory";
// import HisabKitab from "./component/HisabKitab";
// import DeleteGame from "./component/DeleteGame";
// import DeleteClient from "./component/DeleteClient";
// import UpdateResult from "./component/UpdateResult";
// import LaserBook from "./component/LaserBook";
// import UserBetsAndRevert from "./component/UserBetsAndRevert";
// import LainDain from "./component/LainDain";
// import APKInfo from "./component/APKInfo";
// import { Helmet } from "react-helmet";


// function App() {

//   const { direction } = screenOrientation();
//   const { load, loadColor } = useContext(Context);

//   return (
//     <>
//       <Helmet>
//         <title>Matka Jantri | India’s Trusted Online Jantri Calculator & Record Maintainer for Matka Games</title>

//         <meta name="description"
//           content="Use Matka Jantri – India’s trusted online jantri calculator and matka record maintainer. APK for accurate and fast results. Easy to use on mobile and web." />

//         <meta name="keywords"
//           content="jantri, Matka Jantri, jantri calculator, matka games, jantri apk, record maintainer matka, satta matka jantri, jod calculator" />

//         <meta name="author" content="Matka Jantri Team (Miraj Sport's)" />

//         <meta property="og:title" content="Matka Jantri | Online Jantri Calculator for Matka Games" />
//         <meta property="og:description"
//           content="Free jantri calculator and record maintainer APK for matka games. Try Matka Jantri online – fast, accurate and easy to use." />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content="https://pushpabetfair.com" />
//         <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
//         <meta name="google-site-verification" content="d6d81656210c6db7" />
//       </Helmet>



//       <ToastContainer
//         position="top-right"
//         autoClose={5000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="light"
//       />
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         position: 'absolute',
//         top: "50%",
//         left: "50%",
//         zIndex: 100000,
//         transform: "translate(-50%, -50%)",
//       }}>
//         <RotatingLines
//           visible={load ? true : false}
//           height="96"
//           width="96"
//           color="grey"
//           strokeColor={loadColor}
//           strokeWidth="5"
//           animationDuration="0.75"
//           ariaLabel="rotating-lines-loading"
//           wrapperStyle={{}}
//           wrapperClass=""
//         />
//       </div>
//       <Routes>
//         <Route path="/" element={direction === "landscape" ? <Login /> : <LoginP />} />
//         <Route path="/game" element={<GamePage />} exact />
//         <Route path="/gameCutting" element={<CutPage />} exact />
//         <Route path="/deposit/depositMoney" element={<Deposit />} exact />
//         <Route path="/deposit/depositHistory" element={<DepositHistory />} exact />
//         <Route path="/withdraw/withdrawMoney" element={<Withdraw />} exact />
//         <Route path="/withdraw/withdrawHistory" element={<WithdrawHistory />} exact />
//         <Route path="/AddClient" element={<AddClient />} exact />
//         <Route path="/EditClient" element={<EditClient />} exact />
//         <Route path="/AddGame" element={<AddGame />} exact />
//         <Route path="/DeleteJantri" element={<DeleteJantri />} exact />
//         <Route path="/UpdateResult" element={<UpdateResult />} exact />
//         <Route path="/RechargePlans" element={<RechargePlans />} exact />
//         <Route path="/helpSupport" element={<HelpSupport />} exact />
//         <Route path="/betHistory" element={<BetHistory />} exact />
//         <Route path="/hisabKitab" element={<HisabKitab />} exact />
//         <Route path="/deleteGame" element={<DeleteGame />} exact />
//         <Route path="/deleteClient" element={<DeleteClient />} exact />
//         <Route path="/laserBook" element={<LaserBook />} exact />
//         <Route path="/userBetsAndRevert" element={<UserBetsAndRevert />} exact />
//         <Route path="/lainDain" element={<LainDain />} exact />
//         <Route path="/apk-nfo" element={<APKInfo />} exact />
//       </Routes>
//     </>
//   );
// }

// export default App;

import { ToastContainer } from "react-toastify";
import GamePage from "./component/GamePage";
import CutPage from "./component/CutPage";
import Login from "./component/Login";
import { Route, Routes } from "react-router-dom";
import { useContext } from "react";
import { Context } from "./Context/Context";
import { RotatingLines } from "react-loader-spinner";
import Deposit from "./component/Deposit";
import DepositHistory from "./component/DepositHistory";
import WithdrawHistory from "./component/WithdrawHistory";
import AddClient from "./component/AddClient";
import EditClient from "./component/EditClient";
import AddGame from "./component/AddGame";
import DeleteJantri from "./component/DeleteJantri";
import RechargePlans from "./component/RechargePlans";
import Withdraw from "./component/Withdraw";
import LoginP from "./component/LoginP";
import screenOrientation from "screen-orientation";
import HelpSupport from "./component/HelpSupport";
import VideoTutorial from "./component/VideoTutorial";
import BetHistory from "./component/BetHistory";
import HisabKitab from "./component/HisabKitab";
import DeleteGame from "./component/DeleteGame";
import DeleteClient from "./component/DeleteClient";
import UpdateResult from "./component/UpdateResult";
import LaserBook from "./component/LaserBook";
import UserBetsAndRevert from "./component/UserBetsAndRevert";
import LainDain from "./component/LainDain";
import APKInfo from "./component/APKInfo";
import { Helmet } from "react-helmet";

function App() {
  const { direction } = screenOrientation();
  const { load, loadColor } = useContext(Context);

  return (
    <>
      <Helmet>
        <title>Matka Jantri | India’s Trusted Online Jantri Calculator & Record Maintainer for Matka Games</title>
        <meta
          name="description"
          content="Use Matka Jantri – India’s trusted online jantri calculator and matka record maintainer. APK for accurate and fast results. Easy to use on mobile and web."
        />
        <meta
          name="keywords"
          content="jantri, Matka Jantri, jantri calculator, matka games, jantri apk, record maintainer matka, satta matka jantri, jod calculator"
        />
        <meta name="author" content="Matka Jantri Team (Miraj Sport's)" />
        <meta property="og:title" content="Matka Jantri | Online Jantri Calculator for Matka Games" />
        <meta
          property="og:description"
          content="Free jantri calculator and record maintainer APK for matka games. Try Matka Jantri online – fast, accurate and easy to use."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://pushpabetfair.com" />
        <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
        <meta name="google-site-verification" content="d6d81656210c6db7" />
        {/* Favicon and icons */}
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      </Helmet>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          zIndex: 100000,
          transform: "translate(-50%, -50%)",
        }}
      >
        <RotatingLines
          visible={load ? true : false}
          height="96"
          width="96"
          color="grey"
          strokeColor={loadColor}
          strokeWidth="5"
          animationDuration="0.75"
          ariaLabel="rotating-lines-loading"
        />
      </div>

      <Routes>
        <Route path="/" element={direction === "landscape" ? <Login /> : <LoginP />} />
        <Route path="/game" element={<GamePage />} />
        <Route path="/gameCutting" element={<CutPage />} />
        <Route path="/deposit/depositMoney" element={<Deposit />} />
        <Route path="/deposit/depositHistory" element={<DepositHistory />} />
        <Route path="/withdraw/withdrawMoney" element={<Withdraw />} />
        <Route path="/withdraw/withdrawHistory" element={<WithdrawHistory />} />
        <Route path="/AddClient" element={<AddClient />} />
        <Route path="/EditClient" element={<EditClient />} />
        <Route path="/AddGame" element={<AddGame />} />
        <Route path="/DeleteJantri" element={<DeleteJantri />} />
        <Route path="/UpdateResult" element={<UpdateResult />} />
        <Route path="/RechargePlans" element={<RechargePlans />} />
        <Route path="/helpSupport" element={<HelpSupport />} />
        <Route path="/betHistory" element={<BetHistory />} />
        <Route path="/hisabKitab" element={<HisabKitab />} />
        <Route path="/deleteGame" element={<DeleteGame />} />
        <Route path="/deleteClient" element={<DeleteClient />} />
        <Route path="/laserBook" element={<LaserBook />} />
        <Route path="/userBetsAndRevert" element={<UserBetsAndRevert />} />
        <Route path="/lainDain" element={<LainDain />} />
        <Route path="/apk-nfo" element={<APKInfo />} />
        <Route path="/videoTutorial" element={<VideoTutorial />} />
      </Routes>
    </>
  );
}

export default App;
